import { HStack, useToast } from '@chakra-ui/react';
import CustomFilterBtn from '@Modules/core/components/form/CustomFilterBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import CardField from '@Modules/fraudManagement/components/CardField';
import CustomCardTable from '@Modules/fraudManagement/components/CustomCardTable';
import GenericFormUI from '@Shared/components/form/GenericFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getHolderReferentialValuesDataTableColumns, THolderReferentialValuesDataTableData } from './HolderReferentialValuesDataTableMeta';
import holderReferentialValuesFilterFormMeta from './HolderReferentialValuesFilterFormMeta';
import holderReferentialValuesFormMeta from './HolderReferentialValuesFormMeta';

const dateMeta = {...holderReferentialValuesFormMeta}
delete dateMeta.dayUsedGlobalCard

const usedDayMeta = {...holderReferentialValuesFormMeta}
delete usedDayMeta.month
delete usedDayMeta.year

const initAuthorizationData: THolderReferentialValuesDataTableData[] = [
  {
    primaryKey: 1,
    type: "Essai PIN Invalide :",
    number: "1234567890",
    amount: ""
  },
  {
    primaryKey: 2,
    type: "Clef Entrée :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 3,
    type: "POS02 :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 4,
    type: "Rejeté :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 5,
    type: "Total :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 6,
    type: "Jour Utilis. Carte :",
    number: "",
    
  },
];

const initTransactionData: THolderReferentialValuesDataTableData[] = [
  {
    primaryKey: 3,
    type: "POS02 :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 5,
    type: "Total :",
    number: "",
    amount: ""
  },
  {
    primaryKey: 6,
    type: "Jour Utilis. Carte :",
    number: "",
  },
]

const HolderReferentialValuesDataTableHandler = () => {
    
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ["AuthorizationDataTable"];
  const {
    data: authorizationData,
    isLoading: authorizationIsLoading,
  } = useQuery<THolderReferentialValuesDataTableData[]>({
    queryKey: queryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve([
              {
                primaryKey: 1,
                type: "Essai PIN Invalide :",
                number: "1234567890",
                amount: ""
              },
              {
                primaryKey: 2,
                type: "Clef Entrée :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 3,
                type: "POS02 :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 4,
                type: "Rejeté :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 5,
                type: "Total :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 6,
                type: "Jour Utilis. Carte :",
                number: "",
                
              },
            ]), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const transactionQueryKey = ["TransactionDataTable"];
  const {
    data: transactionData,
    isLoading: transactionIsLoading,
  } = useQuery<THolderReferentialValuesDataTableData[]>({
    queryKey: transactionQueryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve([
              {
                primaryKey: 3,
                type: "POS02 :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 5,
                type: "Total :",
                number: "",
                amount: ""
              },
              {
                primaryKey: 6,
                type: "Jour Utilis. Carte :",
                number: "",
              },
            ]), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  
  const { isLoading: isSubmitting } = useMutation( async() =>{}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const authorizationColumns = getHolderReferentialValuesDataTableColumns({
    isLoading: authorizationIsLoading,
  });

  const transactionColumns = getHolderReferentialValuesDataTableColumns({
    isLoading: transactionIsLoading,
  });
  
  const isLoading = authorizationIsLoading && transactionIsLoading;
  return (
    <>
      <GenericFormUI
          meta={holderReferentialValuesFilterFormMeta}
          onSubmit={onSubmit}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          submitBtn={
            <HStack my={4} justifyContent={'flex-end'}>
              <CustomFilterBtn isLoading={isLoading} />
            </HStack>
          }
          mb={16}
        />
      
      <CC.Center>
      <GenericFormUI
          meta={dateMeta}
          onSubmit={onSubmit}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          submitBtn={<></>}
          mb={4}
        />

      </CC.Center>

      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
      <CustomCardTable title='Autorisation' data={authorizationData || initAuthorizationData} columns={authorizationColumns} />

      <CC.VStack rowGap={4}>

      <CustomCardTable title='Transaction' data={transactionData || initTransactionData} columns={transactionColumns} />
        
      <CC.Skeleton isLoaded={!isLoading}>
        <CC.HStack mr={'auto'}>
          <CC.Text w={'90%'}>{holderReferentialValuesFormMeta.dayUsedGlobalCard?.label}</CC.Text>
         <CardField value={""} />
        </CC.HStack>

      </CC.Skeleton>
      </CC.VStack>


      </CC.SimpleGrid>

    </>
  );
};

export default HolderReferentialValuesDataTableHandler;
